import TopbarToggleButton from "./TopbarToggleButton";
import TopbarTabs from "./TopbarTabs";
import React from "react";

export default function LeftTopbarItems() {
    return (
        <>
            <TopbarToggleButton />
            {/*<TopbarTabs />*/}
        </>
    )
}